import type { FC } from "react";
import { useLocation } from "react-router-dom";

import { blogNavigation } from "./BlogNavigation";
import type { IPostTile } from "./PostTile";
import { Timeline } from "./Timeline";

export interface IPostsList {
    title: string;
    subTitle: string;
    posts: IPostTile[];
    numberOfPages: number;
}

const PostsList: FC<IPostsList & { page: number }> = (props) => {
    const { pathname } = useLocation();

    return (
        <>
            <Timeline timeLimeList={props.posts} />
            {blogNavigation(pathname, props.numberOfPages, props.page)}
        </>
    );
};

export default PostsList;
